export const surveyStyles = `
.feedback-survey-container {
  display: none;
}

.feedback-survey-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: var(--z-modal-backdrop);
  animation: fadeIn var(--transition-slow);
}

.feedback-survey-backdrop-dark {
  background: rgba(2, 6, 23, 0.65);
}

/* ========================================
   SURVEY CARD
   ======================================== */

.feedback-survey {
  position: fixed;
  z-index: var(--z-modal);
  background: var(--color-white);
  border: 1px solid var(--color-neutral-200);
  border-radius: var(--radius-xl);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  padding: var(--spacing-6);
  min-width: 320px;
  max-width: 400px;
  font-family: inherit;
  overflow: hidden;
  opacity: 0;
  transition: opacity 200ms ease, transform 240ms cubic-bezier(0.16, 1, 0.3, 1);
}

/* ========================================
   DARK THEME
   ======================================== */

.feedback-survey-theme-dark {
  --color-white: #0f1317;
  --color-background: #0f1317;
  --color-surface: #1a1e24;
  --color-border: #232930;
  --color-neutral-50: #1a1e24;
  --color-neutral-100: #1a1e24;
  --color-neutral-200: #232930;
  --color-neutral-300: #2d343c;
  --color-neutral-400: #555555;
  --color-neutral-500: #777777;
  --color-neutral-900: #e8e8e8;
  --color-text-primary: #e8e8e8;
  --color-text-secondary: #999999;
  --color-text-tertiary: #666666;
  --color-primary-light: rgba(21, 94, 239, 0.18);
  --color-primary-border: rgba(21, 94, 239, 0.4);
  --color-error-light: rgba(239, 68, 68, 0.15);
  --color-error-border: rgba(239, 68, 68, 0.25);
  --color-error-dark: #fca5a5;
}

/* ========================================
   POSITION VARIANTS + ENTRANCE STATES
   ======================================== */

.feedback-survey-right {
  bottom: var(--spacing-6);
  right: var(--spacing-6);
  transform: translateY(10px);
}

.feedback-survey-left {
  bottom: var(--spacing-6);
  left: var(--spacing-6);
  transform: translateY(10px);
}

.feedback-survey-center {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.97);
}

/* ========================================
   CLOSE BUTTON
   ======================================== */

.feedback-survey-close {
  position: absolute;
  top: var(--spacing-4);
  right: var(--spacing-4);
  background: none;
  border: none;
  cursor: pointer;
  color: var(--color-neutral-500);
  padding: 4px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-md);
  transition: all var(--transition-base);
}

.feedback-survey-close iconify-icon {
  display: block;
}

.feedback-survey-close:hover {
  background: var(--color-neutral-100);
  color: var(--color-neutral-900);
}

.feedback-survey-close:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--color-primary-light);
}

/* ========================================
   TYPOGRAPHY
   ======================================== */

.feedback-survey-title {
  margin: 0 0 var(--spacing-3) 0;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-snug);
  padding-right: 36px;
  color: var(--color-text-primary);
}

.feedback-survey-description {
  color: var(--color-text-secondary);
  margin: 0 0 var(--spacing-4) 0;
  font-size: var(--font-size-base);
  line-height: var(--line-height-relaxed);
}

.feedback-survey-description-primary .feedback-survey-description {
  color: var(--color-text-primary);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-snug);
  padding-right: 36px;
}

.feedback-survey-content {
  margin-bottom: var(--spacing-3);
}

/* ========================================
   PROGRESS BAR
   ======================================== */

.feedback-survey-progress {
  margin-bottom: var(--spacing-4);
}

.feedback-survey-progress-track {
  height: 3px;
  background: var(--color-neutral-200);
  border-radius: var(--radius-full);
  overflow: hidden;
}

.feedback-survey-progress-fill {
  height: 100%;
  background: var(--color-primary);
  border-radius: var(--radius-full);
  transition: width 320ms cubic-bezier(0.16, 1, 0.3, 1);
}

/* ========================================
   NPS — individual colored buttons
   ======================================== */

.feedback-survey-nps {
  display: flex;
  justify-content: space-between;
  gap: var(--spacing-1);
}

.feedback-survey-nps-btn {
  flex: 1;
  height: 40px;
  min-height: unset;
  border-radius: 6px;
  cursor: pointer;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: #ffffff;
  border: 1px solid transparent;
  transition: filter var(--transition-fast), transform var(--transition-fast);
  font-family: inherit;
}

.feedback-survey-nps-btn:hover {
  filter: brightness(1.12);
}

.feedback-survey-nps-btn.selected {
  filter: brightness(0.82);
  box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.25);
}

.feedback-survey-nps-btn:active {
  transform: translateY(1px);
  transition-duration: 100ms;
}

/* NPS score colors */
.feedback-survey-nps-score-0  { background: #dc2626; border-color: #dc2626; }
.feedback-survey-nps-score-1  { background: #ef4444; border-color: #ef4444; }
.feedback-survey-nps-score-2  { background: #f97316; border-color: #f97316; }
.feedback-survey-nps-score-3  { background: #fb923c; border-color: #fb923c; }
.feedback-survey-nps-score-4  { background: #fdba74; border-color: #fdba74; }
.feedback-survey-nps-score-5  { background: #fbbf24; border-color: #fbbf24; }
.feedback-survey-nps-score-6  { background: #fde047; border-color: #fde047; color: #171717; }
.feedback-survey-nps-score-7  { background: #e5e7eb; border-color: #e5e7eb; color: #374151; }
.feedback-survey-nps-score-8  { background: #e5e7eb; border-color: #e5e7eb; color: #374151; }
.feedback-survey-nps-score-9  { background: #4ade80; border-color: #4ade80; }
.feedback-survey-nps-score-10 { background: #16a34a; border-color: #16a34a; }

/* ========================================
   CSAT — emoji row
   ======================================== */

.feedback-survey-csat {
  display: flex;
  justify-content: space-between;
  gap: var(--spacing-3);
  padding: var(--spacing-2) 0;
}

.feedback-survey-csat-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 32px;
  transition: transform var(--transition-fast), opacity var(--transition-fast);
  padding: var(--spacing-2) var(--spacing-1);
  min-width: 44px;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-lg);
  line-height: 1;
}

.feedback-survey-csat-btn:hover {
  transform: scale(1.15);
}

.feedback-survey-csat-btn.selected {
  transform: scale(1.2);
}

.feedback-survey-csat:has(.selected) .feedback-survey-csat-btn:not(.selected) {
  transform: scale(0.85);
  opacity: 0.3;
}

.feedback-survey-csat-btn:active {
  transform: scale(1.05) translateY(1px);
  transition-duration: 100ms;
}

.feedback-survey-csat-btn.selected:active {
  transform: scale(1.2) translateY(1px);
}

/* ========================================
   NUMBER RATING (segmented scale)
   ======================================== */

.feedback-survey-rating-scale {
  display: flex;
  overflow: hidden;
  border: 1px solid var(--color-neutral-200);
  border-radius: 6px;
  background: var(--color-white);
}

.feedback-survey-rating-scale-btn {
  flex: 1;
  height: 40px;
  padding: 0;
  border: 0;
  border-right: 1px solid var(--color-neutral-200);
  border-radius: 0;
  background: var(--color-white);
  cursor: pointer;
  font-size: clamp(14px, 3vw, 18px);
  font-weight: var(--font-weight-medium);
  color: #374151;
  transition: background var(--transition-fast), color var(--transition-fast);
  font-family: inherit;
}

.feedback-survey-rating-scale-btn:last-child {
  border-right: none;
}

.feedback-survey-rating-scale-btn:hover {
  background: var(--color-primary-light);
  color: var(--color-primary);
}

.feedback-survey-rating-scale-btn:focus-visible {
  outline: none;
  z-index: 1;
  box-shadow: inset 0 0 0 2px var(--color-primary);
}

.feedback-survey-rating-scale-btn.selected {
  background: var(--color-primary-light);
  color: var(--color-primary-active);
  box-shadow: inset 0 0 0 2px var(--color-primary);
}

.feedback-survey-rating-scale-btn:active {
  transform: translateY(1px);
  transition-duration: 100ms;
}

/* ========================================
   STARS
   ======================================== */

.feedback-survey-stars {
  display: flex;
  gap: var(--spacing-2);
  justify-content: center;
}

.feedback-survey-star-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  line-height: 1;
  color: var(--color-neutral-300);
  transition: color var(--transition-fast), transform var(--transition-fast);
  display: flex;
  align-items: center;
  justify-content: center;
}

.feedback-survey-star-btn iconify-icon {
  display: block;
  pointer-events: none;
  flex-shrink: 0;
}

.feedback-survey-star-btn.filled,
.feedback-survey-star-btn.hovered {
  color: #f59e0b;
}

.feedback-survey-star-btn:hover {
  color: #f59e0b;
}

.feedback-survey-star-btn:active {
  transform: scale(0.9);
  transition-duration: 100ms;
}

/* ========================================
   SCALE LABELS
   ======================================== */

.feedback-survey-labels {
  display: flex;
  justify-content: space-between;
  margin-top: var(--spacing-2);
  padding: 0 var(--spacing-1);
  font-size: var(--font-size-xs);
  color: var(--color-text-tertiary);
}

/* ========================================
   FORM INPUTS
   ======================================== */

.feedback-survey-feedback {
  margin-top: var(--spacing-4);
}

.feedback-survey-textarea {
  width: 100%;
  padding: var(--spacing-3);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  font-size: var(--font-size-base);
  resize: vertical;
  height: 80px;
  background: var(--color-white);
  color: var(--color-text-primary);
  font-family: inherit;
  box-sizing: border-box;
  transition: border-color var(--transition-base);
  outline: none;
}

.feedback-survey-textarea::placeholder {
  color: var(--color-text-tertiary);
}

.feedback-survey-textarea:focus {
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px var(--color-primary-light);
}

/* ========================================
   MULTI-PAGE TEXT INPUT
   ======================================== */

.feedback-survey-page-textarea {
  width: 100%;
  min-height: 120px;
  padding: var(--spacing-3);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-family: inherit;
  background: var(--color-white);
  color: var(--color-text-primary);
  box-sizing: border-box;
  resize: vertical;
  outline: none;
  transition: border-color var(--transition-base);
}

.feedback-survey-page-textarea::placeholder {
  color: var(--color-text-tertiary);
}

.feedback-survey-page-textarea:focus {
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px var(--color-primary-light);
}

/* ========================================
   MULTIPLE CHOICE
   ======================================== */

.feedback-survey-multiple-choice {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
}

.feedback-survey-page-choice-btn {
  width: 100%;
  height: 40px;
  padding: 0 var(--spacing-4);
  border: 1px solid var(--color-neutral-200);
  border-radius: var(--radius-md);
  background: var(--color-white);
  color: #374151;
  text-align: left;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  font-family: inherit;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all var(--transition-fast);
}

.feedback-survey-page-choice-btn::after {
  content: '';
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1.5px solid #D1D5DB;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  transition: all var(--transition-fast);
}

.feedback-survey-page-choice-btn:hover {
  border-color: var(--color-primary);
  background: var(--color-primary-light);
  color: var(--color-primary);
}

.feedback-survey-page-choice-btn:hover::after {
  border-color: var(--color-primary);
}

.feedback-survey-page-choice-btn.selected {
  border-color: var(--color-primary);
  background: var(--color-primary-light);
  color: var(--color-primary-active);
}

.feedback-survey-page-choice-btn.selected::after {
  content: '✓';
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  border-color: var(--color-primary);
  background-color: var(--color-primary);
}

.feedback-survey-page-choice-btn:active {
  transform: translateY(1px);
  transition-duration: 100ms;
}

/* ========================================
   ACTIONS
   ======================================== */

.feedback-survey-actions {
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
  margin-top: var(--spacing-4);
}

.feedback-survey-back {
  padding: 0 var(--spacing-4);
  min-height: 40px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-white);
  color: var(--color-text-secondary);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  font-family: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-2);
  transition: all var(--transition-fast);
  flex: 1;
  white-space: nowrap;
}

.feedback-survey-back:hover {
  background: var(--color-neutral-100);
  border-color: var(--color-neutral-300);
  color: var(--color-text-primary);
}

.feedback-survey-back:active {
  transform: translateY(1px);
  transition-duration: 100ms;
}

/* ========================================
   SUBMIT BUTTON
   ======================================== */

.feedback-survey-submit {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-2);
  min-height: 40px;
  padding: 0 var(--spacing-4);
  background: var(--color-primary);
  color: #ffffff;
  border: 1px solid var(--color-primary);
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  font-family: inherit;
  text-align: center;
  transition: all var(--transition-base);
}

.feedback-survey-submit:hover:not(:disabled) {
  background: var(--color-primary-hover);
  border-color: var(--color-primary-hover);
}

.feedback-survey-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.feedback-survey-submit:active:not(:disabled) {
  transform: translateY(1px);
  transition-duration: 100ms;
}

.feedback-survey-submit iconify-icon,
.feedback-survey-back iconify-icon {
  flex-shrink: 0;
}

/* ========================================
   ERROR
   ======================================== */

.feedback-survey-error {
  margin-bottom: var(--spacing-3);
  background: #D13212;
  border-radius: var(--radius-md);
  color: #ffffff;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  padding: var(--spacing-3) var(--spacing-4);
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
}

.feedback-survey-error iconify-icon {
  flex-shrink: 0;
}

/* ========================================
   THANK YOU SCREEN
   ======================================== */

.feedback-survey-thankyou {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: var(--spacing-6) 0;
}

.feedback-survey-thankyou-icon {
  color: #10b981;
  margin-bottom: var(--spacing-4);
  display: block;
}

.feedback-survey-thankyou-title {
  margin: 0;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-snug);
  color: var(--color-text-primary);
}

.feedback-survey-thankyou-btn {
  margin-top: var(--spacing-5);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-2);
  height: 40px;
  padding: 0 var(--spacing-6);
  background: var(--color-primary);
  color: #ffffff;
  border: 1px solid var(--color-primary);
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  text-decoration: none;
  transition: all var(--transition-base);
}

.feedback-survey-thankyou-btn:hover {
  background: var(--color-primary-hover);
  border-color: var(--color-primary-hover);
  color: #ffffff;
  text-decoration: none;
}

/* ========================================
   DARK MODE — SELECTED STATE OVERRIDES
   ======================================== */

.feedback-survey-theme-dark .feedback-survey-page-choice-btn.selected,
.feedback-survey-theme-dark .feedback-survey-rating-scale-btn.selected,
.feedback-survey-theme-dark .feedback-survey-nps-btn.selected {
  color: var(--color-text-primary);
}

/* ========================================
   NOTIFICATION TOASTS
   ======================================== */

.product7-notification {
  position: fixed;
  top: var(--spacing-6);
  right: var(--spacing-6);
  padding: var(--spacing-3) var(--spacing-5);
  border-radius: var(--radius-xl);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  z-index: var(--z-notification);
  box-shadow: var(--shadow-lg);
  font-family: inherit;
  color: #fff;
}

.product7-notification > div {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
}

.product7-notification svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.product7-notification-success { background: #037F0C; }
.product7-notification-error   { background: #D13212; }
.product7-notification-warning { background: #FF9900; color: #000; }
.product7-notification-info    { background: #0972D3; }

/* ========================================
   RESPONSIVE
   ======================================== */

@media (max-width: 768px) {
  .feedback-survey {
    min-width: 288px;
    padding: var(--spacing-5);
  }

  .feedback-survey-nps-btn {
    font-size: var(--font-size-xs);
  }

  .feedback-survey-csat-btn {
    font-size: 28px;
    min-width: 40px;
    min-height: 40px;
  }

  .feedback-survey-title {
    font-size: var(--font-size-lg);
  }

  .feedback-survey-description-primary .feedback-survey-description {
    font-size: var(--font-size-md);
  }

  .feedback-survey-rating-scale-btn {
    font-size: clamp(13px, 5vw, 16px);
  }
}
`;
